module.exports = __webpack_public_path__ + "assets/img/ithrive-games.70141a81.png";